var Flickity = require("flickity");

const ExampleComponent1 = {
  init() {
    var elem = document.getElementById("vnx-home-trust");
    if (elem) {
      new Flickity(elem, {
        cellAlign: "left",
        contain: true,
        prevNextButtons: false,
        pageDots: true,
      });
    }

    var elem2 = document.getElementById("vnx-home-testimonials");
    if (elem2) {
      new Flickity(elem2, {
        cellAlign: "left",
        contain: true,
        pageDots: false,
      });
    }

    var elem3 = window.document.querySelector("#vnx-list-domain");
    if (elem3) {
      new Flickity(elem3, {
        cellAlign: "left",
        wrapAround: true,
        contain: true,
        pageDots: false,
      });
    }
  },
};

export default ExampleComponent1;
